export const APPEARANCE_STORAGE_KEY = "appearanceMode";
export const APPEARANCE_MODES = Object.freeze(["system", "light", "dark"]);

export function isAppearanceMode(value) {
  return APPEARANCE_MODES.includes(value);
}

export function readStoredAppearanceMode() {
  try {
    const raw = window.localStorage.getItem(APPEARANCE_STORAGE_KEY);
    if (isAppearanceMode(raw)) return raw;
  } catch {
    /* ignore */
  }
  return "system";
}

export function writeStoredAppearanceMode(mode) {
  if (!isAppearanceMode(mode)) return;
  try {
    window.localStorage.setItem(APPEARANCE_STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}

export function getSystemResolvedTheme() {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function resolveTheme(mode) {
  const m = isAppearanceMode(mode) ? mode : "system";
  if (m === "system") return getSystemResolvedTheme();
  return m;
}

export function applyResolvedTheme(resolved) {
  const theme = resolved === "dark" ? "dark" : "light";
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.style.colorScheme = theme;
}

export function applyAppearanceMode(mode) {
  const normalized = isAppearanceMode(mode) ? mode : "system";
  applyResolvedTheme(resolveTheme(normalized));
  return normalized;
}

/** Persist + apply + notify React ThemeProvider (and other listeners). */
export function applyAndStoreAppearanceMode(mode) {
  const normalized = applyAppearanceMode(mode);
  writeStoredAppearanceMode(normalized);
  try {
    window.dispatchEvent(
      new CustomEvent("cm-appearance-mode", { detail: { mode: normalized } })
    );
  } catch {
    /* ignore */
  }
  return normalized;
}

/** Normalize server/person field (camel or Pascal). */
export function appearanceModeFromPerson(person) {
  if (!person || typeof person !== "object") return null;
  const raw = person.appearanceMode ?? person.AppearanceMode;
  return isAppearanceMode(raw) ? raw : null;
}
